import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { TrustBadgeSection } from './components/TrustBadgeSection';
import { SalesLetterSection } from './components/SalesLetterSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusesSection } from './components/BonusesSection';
import { CheckoutSection } from './components/CheckoutSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { ClosingCTASection } from './components/ClosingCTASection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'HUERTA 360°';
  }, []);
  return <div className="min-h-screen bg-black text-zinc-200 font-sans selection:bg-green-500/30 selection:text-green-200" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBadgeSection data-id="element-4" />
        <SalesLetterSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <BonusesSection data-id="element-7" />
        <CheckoutSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <ObjectionsSection data-id="element-10" />
        <ClosingCTASection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <PurchasePopup data-id="element-14" />
    </div>;
}